import xugarHeroStatusApi from '../../../api/xugarHero';

const SET_XUGARHERO_STATUS = 'SET_XUGARHERO_STATUS';
const START_XUGARHERO_STATUS_POOL = 'START_XUGARHERO_STATUS_POOL';
const STOP_XUGARHERO_STATUS_POOL = 'STOP_XUGARHERO_STATUS_POOL';
const SET_XUGARHERO_VARIABLE = 'SET_XUGARHERO_VARIABLE';

const state = {
  xugarHeroStatus: {
    variableId: null,
    lastUpdate: undefined,
    timeInTarget: undefined,
    glucoseThresholds: {},
    lastGloucoseRead: undefined
  },
  xugarHeroStatusPool: undefined
};

const getters = {
  getXugarHeroStatus: state => {
    return state.xugarHeroStatus;
  }
};

const mutations = {
  [SET_XUGARHERO_STATUS] (state, xugarHeroStatus) {
    state.xugarHeroStatus = xugarHeroStatus;
  },

  [SET_XUGARHERO_VARIABLE] (state, id) {
    state.xugarHeroStatus.variableId = id;
  },

  [START_XUGARHERO_STATUS_POOL] (state, {context}) {
    xugarHeroStatusApiCall(context);
    state.xugarHeroStatusPool = setInterval(() => {
      xugarHeroStatusApiCall(context);
    }, 60000);
  },

  [STOP_XUGARHERO_STATUS_POOL] (state) {
    if (state.xugarHeroStatusPool) {
      clearInterval(state.xugarHeroStatusPool);
      state.xugarHeroStatusPool = undefined;
    }
  }
};

const actions = {
  startRetrieveXugarHeroStatus ({ commit }, {context}) {
    commit(START_XUGARHERO_STATUS_POOL, {context});
  },

  stopRetrieveXugarHeroStatus ({ commit }, {context}) {
    commit(STOP_XUGARHERO_STATUS_POOL, {context});
  },

  retrieveXugarHeroStatus ({ commit }, { context }) {
    return new Promise((resolve, reject) => {
      xugarHeroStatusApi.getXugarHeroStatus(context).then(data => {
        commit(SET_XUGARHERO_STATUS, data);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },

  updateTrackingVariable ({ commit }, { context, variableId }) {
    return new Promise((resolve, reject) => {
      xugarHeroStatusApi.updateTrackingVariable(context, variableId).then(() => {
        commit(SET_XUGARHERO_VARIABLE, variableId);
        resolve();
      }, error => {
        reject(error);
      });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};

const xugarHeroStatusApiCall = (context) => {
  xugarHeroStatusApi.getXugarHeroStatus(context).then(data => {
    state.xugarHeroStatus = data;
  });
};



// WEBPACK FOOTER //
// ./src/brand/xugarhero/store/modules/xugarHero/index.js